import PropTypes from "prop-types";

export const KpisShape = {
  cost: PropTypes.number,
  quality: PropTypes.number,
  time: PropTypes.number,
};
